// http://s-gateway-ci.k8s.zhihuiya.com/s-analytics-workspace/workspace/swagger-ui.html#/
export function makeWorkspaceUrl(server) {
    const M = (j) => server + '/backoffice/proxy/workspace' + j;
    return {
        workspace: {
            /** 数据迁移： DataMigration */
            getTransferHistory: M('/backend-service/bo-copy-space-task'),
            getSpaceOfUser: M('/backend-service/self-space'),
            transfer: M('/backend-service/space/transfer-copy-backoffice'),
            /** 任务中心： taskCenter */
            postTaskAdminQuery: M('/backend-service/admin/task-admin-query'),
            // eslint-disable-next-line no-template-curly-in-string
            putCancelTask: M('/backend-service/admin/task-cancel/admin-id/${admin_id}'),
            taskChart: M('/backend-service/task-chart'),
            summary: M('/data/separation/workspace/summary'),
            /** 冷热数据: Cold Hot Data */
            separateData: M('/data/separation/manual/separate'),
            mergeData: M('/data/separation/manual/load'),
        },
    };
}
